import React from "react";

/**
 * Seletor de horário em formato 12h com AM/PM.
 * Mantém o valor no formato 24h "HH:MM" (compatível com o backend),
 * mas exibe hora (1-12), minuto e período (AM/PM) para evitar confusão.
 */
function parse(value) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(value || "");
  let h24 = 9;
  let min = 0;
  if (m) {
    h24 = Math.min(23, parseInt(m[1], 10) || 0);
    min = Math.min(59, parseInt(m[2], 10) || 0);
  }
  const period = h24 >= 12 ? "PM" : "AM";
  let h12 = h24 % 12;
  if (h12 === 0) h12 = 12;
  return { h12, min, period };
}

function toValue(h12, min, period) {
  let h24 = h12 % 12;
  if (period === "PM") h24 += 12;
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(h24)}:${pad(min)}`;
}

export function TimePicker12h({ value, onChange, testId }) {
  const { h12, min, period } = parse(value);
  const hours = Array.from({ length: 12 }, (_, i) => i + 1);
  const minutes = Array.from({ length: 60 }, (_, i) => i);
  const cls =
    "cm-input !w-auto px-2 py-1.5 text-sm bg-white border border-slate-300 rounded-md focus:border-blue-500 focus:outline-none";

  return (
    <div className="flex items-center gap-1.5" data-testid={testId}>
      <select
        aria-label="Hora"
        data-testid={testId ? `${testId}-hour` : undefined}
        className={cls}
        value={h12}
        onChange={(e) => onChange(toValue(parseInt(e.target.value, 10), min, period))}
      >
        {hours.map((h) => (
          <option key={h} value={h}>
            {h}
          </option>
        ))}
      </select>
      <span className="font-semibold text-slate-500">:</span>
      <select
        aria-label="Minuto"
        data-testid={testId ? `${testId}-minute` : undefined}
        className={cls}
        value={min}
        onChange={(e) => onChange(toValue(h12, parseInt(e.target.value, 10), period))}
      >
        {minutes.map((m) => (
          <option key={m} value={m}>
            {String(m).padStart(2, "0")}
          </option>
        ))}
      </select>
      <select
        aria-label="AM/PM"
        data-testid={testId ? `${testId}-period` : undefined}
        className={cls}
        value={period}
        onChange={(e) => onChange(toValue(h12, min, e.target.value))}
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
}
